import {createContext, useContext} from 'react';
import {
  CountryCode,
  DefaultCurrency,
  GlobalizationPathPrefix,
  GlobalizationPathPrefixData,
  LocaleCode,
  PrefixablePair,
} from 'mkt-ssr/lib/globalization/types';
import {PathPrefixes} from 'mkt-ssr/generated/globalization/pathPrefixes';

const GlobalizationContext = createContext<GlobalizationPathPrefixData>(
  PathPrefixes.us,
);

export const GlobalizationContextProvider = GlobalizationContext.Provider;

export function useGlobalizationPrefixData(): GlobalizationPathPrefixData {
  return useContext(GlobalizationContext);
}

export function useGlobalizationPair(): PrefixablePair {
  return useGlobalizationPrefixData();
}

export function useLocaleCode(): LocaleCode {
  return useGlobalizationPrefixData().locale.code;
}

export function useCountryCode(): CountryCode {
  return useGlobalizationPrefixData().country.code;
}

export function useDefaultCurrency(): DefaultCurrency {
  return useGlobalizationPrefixData().country.defaultCurrency;
}

export function usePrefix(): GlobalizationPathPrefix {
  return useGlobalizationPrefixData().prefix;
}
